import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/investment';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

interface UseCustomTagsParams {
  firmId?: string;
  enabled?: boolean;
}

export function useCustomInvestmentTags(params: UseCustomTagsParams = {}) {
  return useQuery({
    queryKey: ['custom-tags', { params }],
    queryFn: async () => {
      const { data } = await api.get<
        ApiResponse<Api.GetInvestmentCustomTagsResponse>
      >('/investment/custom-tags', { params });
      return data.data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    enabled: params.enabled,
  });
}
